import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'
import Icon from '../../components/Icon'
import { addModal } from '../modals/modalSlice'
import { helpContentSelector } from './HelpContentSlice'
import { _ } from '../../utils/localization'

const S = {
    Content: styled.div`
        overflow-x: hidden
    `
}

export const useOpenHelpModal = () => {
    const dispatch = useDispatch()
    const helpContent = useSelector(helpContentSelector)

    if (!helpContent) {
        return null
    }

    return () => dispatch(addModal({
        Component: () => <S.Content dangerouslySetInnerHTML={{ __html: helpContent }} />,
        size: 'lg',
        header: _('help_context.title'),
    }))
}

const HelpContent = () => {
    const onClick = useOpenHelpModal()

    if (!onClick) {
        return <div style={{ minWidth: 40 }} />
    }

    return (
        <Icon
            icon="question"
            onClick={onClick}
            style={{ marginLeft: 16 }}
        />
    )
}

export default HelpContent
